module.exports = __webpack_public_path__ + "img/jd.16b0f875.png";